<template>
  <div class="question">
    <template v-if="questionnaire_answers">
      <div class="title">1.Which of these best describes you?</div>
      <div class="list">
        <el-radio-group v-model="questionnaire_answers.questions.question1">
          <div class="item f--c">
            <el-radio disabled :label="1">I’m using KakaClo as my start of business</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="2">I'm just using KakaClo for shopping</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="3">I’m already selling online and in person before using KakaClo</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="4">I’m already selling online before using KakaClo</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="5">I’m already selling in person before using KakaClo</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
    <template v-if="questionnaire_answers">
      <div class="title">2.How would you describe your store type?</div>
      <div class="list">
        <el-radio-group v-model="questionnaire_answers.questions.question2">
          <div class="item f--c">
            <el-radio disabled :label="1">FASHION RELATED STORE: a store that has a bunch of fashion related
              products</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="2">ONE-PRODUCT STORE: a store that only focuses on selling one or two main
              products, such as
              a dress store, lingerie store, etc</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="3">GENERAL STORE: a store that has a bunch of products all around it</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
    <template v-if="questionnaire_answers">
      <div class="title">3.What is your store annual revenues?</div>
      <div class="list">
        <el-radio-group v-model="questionnaire_answers.questions.question3">
          <div class="item f--c">
            <el-radio disabled :label="1">Below $50,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="2">In the range from $50,000 to $100,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="3">In the range from $100,000 to $200,000</el-radio>
          </div>
          <div class="item f--c">
            <el-radio disabled :label="4">Over $200,000</el-radio>
          </div>
        </el-radio-group>
      </div>
    </template>
    <div v-if="questionnaire_answers" class="register-info">
      <el-form label-position="top" label-width="80px" ref="resetBusiness" :model="questionnaire_answers.business">
        <el-form-item label="Brand Name">
          <el-input disabled v-model.trim="questionnaire_answers.business.brandName"></el-input>
        </el-form-item>
        <el-form-item label="Website URL">
          <el-input disabled v-model.trim="questionnaire_answers.business.websiteURL"></el-input>
        </el-form-item>
        <el-form-item label="How did you hear about us?">
          <el-select disabled v-model="questionnaire_answers.business.referrer" style="width:100%">
            <el-option label="Social Media" :value="1"></el-option>
            <el-option label="Another Brand" :value="2"></el-option>
            <el-option label="A Wholesaler" :value="3"></el-option>
            <el-option label="A KakaClo Employee" :value="4"></el-option>
            <el-option label="Other" :value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionnaire_answers: undefined
  }
}
</script>

<style lang="scss" scoped>
.question {
  width: 100%;

  .register-info {
    width: 100%;
    margin-top: 24px;

    .send-button {
      width: 92px;
      height: 40px;
      border-radius: 2px;
    }

    .verification {
      /deep/ .el-form-item__content {
        display: flex;
      }
    }

    /deep/ .el-form-item {
      margin-bottom: 20px;
    }

    /deep/ .el-form-item--medium .el-form-item__label {
      width: 100%;
      display: flex;
      line-height: 22px;
      padding-bottom: 4px !important;
    }

    /deep/ .el-form-item__content .el-input__inner {
      border-radius: 2px;
      height: 40px;
    }

    /deep/ .el-input-group__prepend {
      background-color: unset;
    }
  }

  .title {
    font-size: 16px;
    color: #303133;
    padding-left: 10px;
  }

  .list {
    margin-top: 20px;
    height: 280px;

    .item {
      margin-bottom: 16px;

      /deep/ .el-radio {
        width: 100%;
        display: flex;

        .el-radio__input {
          position: relative;
          top: 3.6px;
        }

        .el-radio__label {
          line-height: 22px;
          text-overflow: ellipsis;
          white-space: normal;
        }
      }
    }
  }
}
</style>
